export default __webpack_public_path__ + "static/807-169797ea08739df77b19aacbcd5afba3.gif";